import { DISTRIBUTION_CONSTANTS, STATUS_LABELS } from '../../../../../constants/distribution.constants';
import BundleModel from '../../../../../core/models/distribution/BundleModel';
import VersionModel from '../../../../../core/models/distribution/VersionModel';
import DeleteBundleVersionService from '../../../../../services/deleteBundleVersion/delete.bundle.version.service';
import DistributeService from '../../../../../services/distributeBundleVersion/distribute.bundle.version.service';
import SignBundleVersionService from '../../../../../services/signBundleVersionService/sign.bundle.version.service';
import StopBundleVersionDistributionsService
    from '../../../../../services/stopBundleVersionDistributions/stop.bundle.versions.distributions.service';
import DistributionBundlesDAO from '../../../DAO/bundles/DistributionBundlesDAO';
import CreateBundleComponent from '../create/bundle.create.component';
import EditBundleComponent from '../create/bundle.edit.component';
import BundleVersionComponent from './bundle.version.component';
import BundleVersionDAO from './DAO/BundleVersionDAO';

export default class BundleVersionController {

    constructor(JFrogTableViewOptions, $state, $stateParams, $scope, $window, bundleVersionDAO, JFrogEventBus,
                JFrogUIUtils, JFrogModal, distributionBundlesDAO, $timeout, distributeService, deleteBundleVersionService,
                stopBundleVersionDistributionsService, signBundleVersionService, User, $q, AppContext) {
        this.JFrogTableViewOptions = JFrogTableViewOptions;
        this.$scope = $scope;
        this.$state = $state;
        this.$window = $window;
        this.$q = $q;
        this.AppContext = AppContext;
        this.bundleVersionResource = bundleVersionDAO.Resource;
        this.$stateParams = $stateParams;
        this.daoRequestParams = {
            release_bundle: this.$stateParams.bundle,
            release_bundle_version: this.$stateParams.version,
        };
        this.jFrogEventBus = JFrogEventBus;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.JFrogUIUtils = JFrogUIUtils;
        this.modal = JFrogModal;
        this.DISTRIBUTION_CONSTANTS = DISTRIBUTION_CONSTANTS;
        this.allowedSites = {};
        this.$timeout = $timeout;
        this.distributionBundleResource = distributionBundlesDAO.Resource;

        this.distributeService = distributeService;
        this.deleteBundleVersionService = deleteBundleVersionService;
        this.stopBundleVersionDistributionsService = stopBundleVersionDistributionsService;
        this.signBundleVersionService = signBundleVersionService;
        this.routes = window.store.getters['distribution/GET_ROUTE_CONSTANTS'];
        this.items = [{
            text: 'Distributable',
            to: { name: this.routes.DISTRIBUTION_MAIN, params: { activeTab: 'source' } },
        }, {
            text: this.$stateParams.bundle,
            to: { name: this.routes.DISTRIBUTABLE.RELEASE_BUNDLE, params: { bundle: this.$stateParams.bundle } },
        }, {
            text: this.$stateParams.version,
            to: {
                name: this.routes.DISTRIBUTABLE.RELEASE_BUNDLE_VERSION,
                params: { bundle: this.$stateParams.bundle, version: this.$stateParams.version },
            },
            active: true,
        }];
        this.user = User.getCurrent();
        this.subscribeOnSetNgAppActiveMutation();
    }

    subscribeOnSetNgAppActiveMutation() {
        this.unsubscribeNgAppActiveMutation = window.store.subscribe(async ({ type, payload }) => {
            if (type === 'appLayout/SET_NG_APP_ACTIVE' && payload && payload.status === false) {
                this.cancelPendingAsyncActions();
            }
        });
    }

    showSpinner() {
        window.store.dispatch('ENABLE_LOCAL_LOADER', '.bundle-container');
    }

    hideSpinner() {
        window.store.dispatch('DISABLE_LOCAL_LOADER', '.bundle-container');
    }

    goToBundlesList() {
        this.cancelPendingAsyncActions();
        window.$vueRouter.push({
            name: this.routes.DISTRIBUTION_MAIN,
            params: { activeTab: 'source' },
        });
    }

    goToBundleVersionsList() {
        this.cancelPendingAsyncActions();
        window.$vueRouter.push({
            name: this.routes.DISTRIBUTABLE.RELEASE_BUNDLE,
            params: this.$stateParams,
        });
    }

    resolveBundleVersion() {
        let deferred = this.$q.defer();
        if (!this.$stateParams.bundle || !this.$stateParams.version) {
            this.goToBundlesList();
            deferred.reject();
            return deferred.promise;
        }
        this.bundleVersionResource.getReleaseBundleVersion({
            release_bundle: this.$stateParams.bundle,
            release_bundle_version: this.$stateParams.version,
        }).$promise.then((response) => {
            deferred.resolve(new VersionModel(response));
        }, (response) => {
            if (response.status === 404 || response.status === 403) {
                this.goToBundleVersionsList();
                deferred.reject();
            }
        });
        return deferred.promise;
    }

    resolveBundle() {
        let deferred = this.$q.defer();
        if (!this.$stateParams.bundle || !this.$stateParams.version) {
            this.goToBundlesList();
            deferred.reject();
            return deferred.promise;
        }
        this.distributionBundleResource.getReleaseBundle({
            release_bundle: this.$stateParams.bundle,
        }).$promise.then(
            (response) => {
                deferred.resolve(new BundleModel(response));
            }, (response) => {
                if (response.status === 404 || response.status === 403) {
                    this.goToBundlesList();
                    deferred.reject();
                }
            });
        return deferred.promise;
    }

    versionInitialization() {
        this.initialize();
        this.registerEvents();

        this.tabs = [
            { name: 'content' },
            { name: 'releaseNotes' },
            { name: 'distributionTracking' },
            { name: 'xrayData', isVisible: this.canShowXrayDataTab() },
            { name: 'spec' },
            { name: 'effectivePermissions', isVisible: this.enableViewEffectivePermissions },
        ];

        this.tabsDict = {
            content: 'Content',
            releaseNotes: 'Release Notes',
            distributionTracking: 'Distribution Tracking',
            xrayData: 'Xray Data',
            spec: 'Spec',
            effectivePermissions: 'Effective Permissions',
        };

        this.summaryColumns = this.getSummaryColumns();
        this.jFrogEventBus.dispatch(this.EVENTS.VERSION_ARCHIVE_STATUS, this.version.archived);
        this.publishDistributionStatus();
        this.getAllowedSites(DISTRIBUTION_CONSTANTS.DISTRIBUTION_ACTIONS.DISTRIBUTE);
        this.getAllowedSites(DISTRIBUTION_CONSTANTS.DISTRIBUTION_ACTIONS.DELETE);
        this.refreshVersion(false);
    }

    $onInit() {
        this.showSpinner();
        this.$q.all([this.resolveBundleVersion(), this.resolveBundle()])
            .then(responses => {
                this.version = responses[0];
                this.bundle = responses[1];
                this.versionInitialization();
                this.refreshTabs();
                this.hideSpinner();
            });
    }

    initialize() {
        this.idSelected = this.idSelected || this.$stateParams.version;
        this.renderVersion(this.idSelected);
        this.getPermissions();
        this.watchVersionChanges();
    }

    refreshTabs() {
        const effectivePermissionTab = this.tabs.find(tab => tab.name === 'effectivePermissions');
        if (effectivePermissionTab) {
            effectivePermissionTab.isVisible = this.enableViewEffectivePermissions;
        }
        this.jFrogEventBus.dispatch(this.jFrogEventBus.getEventsDefinition().TABS_REFRESH);
    }

    renderVersion(version, location) {
        this.setSelectedVersion(version);
        this.$state.go(BundleVersionComponent.META.state,
            {
                bundle: this.$stateParams.bundle,
                version: version,
                tab: this.$stateParams.tab || 'content',
            },
            { location: location || true });
    }

    getPermissions() {
        const isAdmin = this.user.isAdmin();
        this.enableViewEffectivePermissions = isAdmin
            || this.version.permissions.some(perm => perm === DISTRIBUTION_CONSTANTS.DISTRIBUTION_ACTIONS.MANAGE_PERMISSIONS);
        this.enableDeleteBundle = isAdmin
            || this.version.permissions.some(perm => perm === DISTRIBUTION_CONSTANTS.DISTRIBUTION_ACTIONS.DELETE);
        this.enableCloneEditBundleVersion = isAdmin
            || this.version.permissions.some(perm => perm === DISTRIBUTION_CONSTANTS.DISTRIBUTION_ACTIONS.WRITE);
        this.enableDistributeBundle = isAdmin
            || this.version.permissions.some(perm => perm === DISTRIBUTION_CONSTANTS.DISTRIBUTION_ACTIONS.DISTRIBUTE);
    }

    onDistribute() {
        this.distributeService.showVersionDistributionModal({
                release_bundle: this.$stateParams.bundle,
                release_bundle_version: this.idSelected,
            },
        );
    }

    setSelectedVersion(version) {
        this.idSelected = version;
    }

    watchVersionChanges() {
        this.$scope.$watch('$ctrl.$stateParams.version', () => {
            if (_.isUndefined(this.$stateParams.version)) {
                this.renderVersion(this.bundle.versions[0], 'replace');
            }
        });
    }

    onToggleArchive() {
        // TODO: Archiving should be displayed and toggled per version so use 2 way binding and change per version
        // => rise an event and catch it in version (then fire a REST that saves the change)
        this.jFrogEventBus.dispatch(this.EVENTS.TOGGLE_VERSION_ARCHIVE);
    }

    onDelete(version) {
        const isLocalDeletion = !this.version.distribution
            || !this.version.distribution.status
            || this.version.distribution.status === STATUS_LABELS.NOT_DISTRIBUTED;
        this.deleteBundleVersionService.showVersionDeletionModal({
            release_bundle: this.$stateParams.bundle,
            release_bundle_version: version || this.idSelected,
        }, null, null, isLocalDeletion);
    }

    // TODO: When migrating this to vue - pass the whole current route (currently angular ui-router does not sync all params with vue router)
    getCurrentRelativeUrl() {
        return `/bundles/source/${this.$stateParams.bundle}/${this.idSelected}`;
    }

    onCloneBundleVersion() {
        this.showSpinner();
        this.cancelPendingAsyncActions();
        const prevUrl = this.getCurrentRelativeUrl();
        this.$state.go(CreateBundleComponent.META.state.name, {
            release_bundle: this.$stateParams.bundle,
            release_bundle_version: this.idSelected,
            prevUrl,
        });
    }

    onEdit() {
        this.showSpinner();
        this.cancelPendingAsyncActions();
        const prevUrl = this.getCurrentRelativeUrl();
        this.$state.go(EditBundleComponent.META.state.name, {
            bundle: this.$stateParams.bundle,
            version: this.idSelected,
            prevUrl,
        });
    }

    onStopDistribution() {
        this.stopBundleVersionDistributionsService.stopDistribution({
            release_bundle: this.$stateParams.bundle,
            release_bundle_version: this.idSelected,
        });
    }

    setDistributionStatus(hasActiveDistribution) {
        this.selectedVersionHasActiveDistribution = hasActiveDistribution;
    }

    setVersionState(state) {
        this.isEditable = state === DISTRIBUTION_CONSTANTS.BUNDLE_VERSION_STATES.OPEN;
    }

    onSign() {
        this.signBundleVersionService.signBundleVersion({
            release_bundle: this.$stateParams.bundle,
            release_bundle_version: this.idSelected,
        });
    }

    cancelPendingAsyncActions() {
        if (this.timeoutRef) {
            this.$timeout.cancel(this.timeoutRef);
        }
        this.cancelPendingRequests();
        if (this.unsubscribeNgAppActiveMutation && typeof this.unsubscribeNgAppActiveMutation === 'function') {
            this.unsubscribeNgAppActiveMutation();
        }
    }

    $onDestroy() {
        this.cancelPendingAsyncActions();
    }

    cancelPendingRequests() {
        this.bundleVersionResource.$cancelAll('getReleaseBundleVersion');
    }

    registerEvents() {

        this.jFrogEventBus.registerOnScope(this.$scope, this.EVENTS.VERSION_SIGNED, () => {
            this.$timeout.cancel(this.timeoutRef);
            this.refreshVersion(true, true);
        });

        this.jFrogEventBus.registerOnScope(this.$scope, this.EVENTS.VERSION_DISTRIBUTED,
            this.restartRefreshVersion.bind(this));

        this.jFrogEventBus.registerOnScope(this.$scope, this.EVENTS.DISTRIBUTION_STOPPED,
            this.restartRefreshVersion.bind(this));

        this.jFrogEventBus.registerOnScope(this.$scope, this.EVENTS.VERSION_ARCHIVE_STATUS,
            status => this.isSelectedVersionArchived = status);

        this.jFrogEventBus.registerOnScope(this.$scope, this.EVENTS.VERSION_ACTIVE_DISTRIBUTION_STATUS,
            hasActiveDistribution => this.setDistributionStatus(hasActiveDistribution));

        this.jFrogEventBus.registerOnScope(this.$scope, this.EVENTS.VERSION_STATE,
            state => this.setVersionState(state));

        this.jFrogEventBus.registerOnScope(this.$scope, this.EVENTS.VERSION_DELETED,
            () => {
                this.initialize();
            });

        //this.jFrogEventBus.registerOnScope(this.$scope, this.EVENTS.TOGGLE_VERSION_ARCHIVE, () => {
        //	// TODO: Archiving should be displayed and toggled per version so use 2 way binding and change per version
        //	// => rise an event and catch it in version (then fire a REST that saves the change)
        //	this.modal
        //	    .confirm(
        //		    `Archive version ${this.$stateParams.bundle} of release bundle ${this.idSelected} ?`,
        //		    'Archive Release Bundle Version', {confirm: 'Archive'})
        //	    .then(() => {
        //		    //this.intervalService.killInterval();
        //		    this.bundleVersionResource.toggleArchiveReleaseBundleVersionLocally({
        //			    release_bundle: this.$stateParams.bundle,
        //			    release_bundle_version: this.$stateParams.version,
        //			    archive: !this.version.archived
        //		    }).$promise.then(response => {
        //			    this.refreshVersion().then(() => {
        //				    this.jFrogEventBus.dispatch(this.EVENTS.VERSION_ARCHIVE_STATUS, this.version.archived);
        //			    });
        //		    });
        //	    });
        //});
    }

    restartRefreshVersion() {
        this.$timeout.cancel(this.timeoutRef);
        this.refreshVersion(false, true);
        this.$state.go(BundleVersionComponent.META.state, {
            bundle: this.$stateParams.bundle,
            version: this.$stateParams.version,
            tab: 'distributionTracking',
        });
    }

    refreshVersion(shouldRefreshVersionContent, noTimeout) {
        this.timeoutRef = this.$timeout(() => {
            this.bundleVersionResource.getReleaseBundleVersion({
                release_bundle: this.$stateParams.bundle,
                release_bundle_version: this.$stateParams.version,
            }).$promise.then(
                (response) => {
                    this.version = new VersionModel(response);
                    if (shouldRefreshVersionContent) {
                        this.jFrogEventBus.dispatch(this.EVENTS.VERSION_CONTENT_REFRESH, this.version);
                    }
                    this.publishDistributionStatus();
                    this.refreshVersion(false);
                }, (error) => {
                    if (error.status === 404 || error.status === 403) {
                        this.goToBundleVersionsList();
                    }
                },
            );
        }, noTimeout ? 0 : DISTRIBUTION_CONSTANTS.DISTRIBUTION_REFRESH_RATE);

    }


    getSummaryColumns() {
        return [{
            class: 'version-id',
            label: 'Version',
            noWrap: true,
            template: `<span jf-tooltip-on-overflow>
							{{$ctrl.version.id || 'No versions'}}
						</span>`,
            isActive: true,
        }, {
            class: 'state',
            label: 'State',
            noWrap: true,
            template: require('./components/versionState/version.state.view.html'),
            isActive: true,
        }, {
            label: `Description`,
            class: 'description',
            noWrap: true,
            template: `<abbraviated-text text="$ctrl.version.description"></abbraviated-text>`,
            isActive: true,
        }, {
            label: 'Created',
            class: 'version-creation-date',
            template: `<span jf-tooltip-on-overflow>
							{{$ctrl.version.created || '--'}}
						</span>`,
            noWrap: true,
            isActive: true,
        }, {
            label: 'Status',
            class: 'status',
            template: `<distribution-status
							description="$ctrl.version.distribution.status.label"
							status="$ctrl.version.distribution.viewStatus"
							more-info="$ctrl.version.state_details">
						</distribution-status>`,
            isActive: true,
        }, {
            label: 'Progress',
            template: `<div>{{$ctrl.version.distribution.viewCoverage}}</div>`,
            isActive: true,
        }, {
            label: 'Size',
            class: 'size',
            template: `<div>{{ $ctrl.version.size | filesize }}</div>`,
            isActive: true,
        }];
    }

    publishDistributionStatus() {
        let hasActiveDistribution =
            this.version.distribution &&
            this.version.distribution.status &&
            (this.version.distribution.status === STATUS_LABELS.NOT_DISTRIBUTED ||
                this.version.distribution.status === STATUS_LABELS.IN_PROGRESS) &&
            this.version.distribution.type === DISTRIBUTION_CONSTANTS.DISTRIBUTION_TYPE.DISTRIBUTE;
        this.jFrogEventBus.dispatch(this.EVENTS.VERSION_ACTIVE_DISTRIBUTION_STATUS, hasActiveDistribution);
        this.jFrogEventBus.dispatch(this.EVENTS.VERSION_STATE, this.version && this.version.state);
    }

    getAllowedSites(action) {
        this.distributionBundleResource.getSites({
            action: action,
            $no_spinner: true,
        }).$promise.then((response) => {
            this.AppContext.setPairingStatus(true);
            this.allowedSites[action] = response.map(s => s.name);
        });
    }

    canShowXrayDataTab() {
        return this.AppContext.hasXray() && this.AppContext.hasXrayLicense();
    }
}

BundleVersionController.$inject = [
    'JFrogTableViewOptions',
    '$state',
    '$stateParams',
    '$scope',
    '$window',
    BundleVersionDAO.META.name,
    'JFrogEventBus',
    'JFrogUIUtils',
    'JFrogModal',
    DistributionBundlesDAO.META.name,
    '$timeout',
    DistributeService.META.name,
    DeleteBundleVersionService.META.name,
    StopBundleVersionDistributionsService.META.name,
    SignBundleVersionService.META.name,
    'User',
    '$q',
    'AppContext',
];



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/components/bundle/version/bundle.version.controler.js